<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
$( document ).ready(function() {    
    $(".m-links .m-nav").hover(function () {
      var dataSrcValue = $(this).data("id");
      var linkText = $(this).find('a').text();   
      $(this).attr("data-menu-active", "true");
      $("#" + dataSrcValue + " ").find('.title-menu').text(linkText);
   });
});

$(".menu-lv-1__action").hover(function () {
  $(".m-links .m-nav").attr("data-menu-active", "false");
  $(".m-sub-nav").hide();
  $('.first-items').attr("data-menu-active", "true");
  $('.m-sub-nav.first-items').css("display", "flex");
});

$(".m-links .m-nav").hover(function () {
  $(".m-links .m-nav").attr("data-menu-active", "false");
  var dataSrcValue = $(this).data("id");
  $(this).attr("data-menu-active", "true");
  $(".m-sub-nav").hide();
  $("#" + dataSrcValue + "").css("display", "flex");
});
<!-- custom-model -->
    $(document).ready(function(){
	$('#videoModalBtn').click(function(event){
		showModal();
		event.stopPropagation(); 
	});
	$('#modalClose').click(function(){
		hideModal();
	});
	
	// Do nothing when clicking on the modal content
	$('.modal-content').click(function(event){
       event.stopPropagation(); 
    });
});

function showModal(){
	$('#myModal').addClass('show');
    $('body').addClass('body-overflow-hidden');
		//(function fun(){
		//	$('.modal-content').css({'transform':'translateY(-50px)'});
		//})();
}

function hideModal(){
	$('#myModal').removeClass('show');
    $('body').removeClass('body-overflow-hidden');
		//(function fun2(){
		//	$('.modal-content').css({ 'transform':'translateY(0px)' });
		//})();
}

$(document).on("click", function () {
  	hideModal();
});
$(".custom-video-content").click(function() {
        var dataSrcValue = $(this).data("src");
        console.log("data-src value:", dataSrcValue);
        $("#custom_video_src").attr("src", dataSrcValue);
        $(".video-main")[0].load();
});
$(document).ready(function(){var maxHeight=0;$(".collection-sub-list .item a span").each(function(){$(".collection-sub-list .item a span").css("height","auto"),$(this).height()>maxHeight&&(maxHeight=$(this).height())}),$(".collection-sub-list .item a span").height(maxHeight)}),$(window).resize(function(){$(".collection-sub-list .item a span").css("height","auto");var maxHeight=0;$(".collection-sub-list .item a span").each(function(){$(this).height()>maxHeight&&(maxHeight=$(this).height())}),$(".collection-sub-list .item a span").height(maxHeight)});

$(document).on("click", ".new-faq-title", function(){
  $(this).toggleClass("active");
  $(this).next(".new-faq-text").slideToggle(150);
})